import { SharedFileRequestContextType } from "@wingspanhq/wingspan-api-sdk";

export function selectorIsSharedFileAutoInsuranceContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return contextType === SharedFileRequestContextType.AUTO_INSURANCE_CARD;
}
